<template>
<section class="bg-gray-100 p-10 mt-10 rounded-lg relative bg-blue-500 py-12">
    <div class="text-center">
        <h2 class="text-2xl font-bold mb-4 text-3xl md:text-4xl font-semibold font-theme-heading text-center ">Rechargez votre téléphone partout dans le monde</h2>
        <p class="text-gray-700 mb-6">Notre application facilite la recharge téléphonique en ligne, vous permettant de rester connecté avec vos proches, où que vous soyez.</p>
    </div>
    <div class="grid grid-cols-1 md:grid-cols-3 gap-8">
        <!-- Fonctionnalité 1 -->
        <div class="text-center">
            
            <img src="../assets/images/Connected-world.svg" alt="Image descriptive 1" class="mx-auto mb-4 h-24 w-24 object-cover rounded-full shadow">
            
            <h3 class="text-xl font-semibold mb-2">Couverture mondiale</h3>
            <p class="text-gray-600">Rechargez dans plus de 150 pays avec un processus en quelques clics.</p>
        </div>
        <!-- Fonctionnalité 2 -->
        <div class="text-center">
            <img src="../assets/images/Safe-bro.svg" alt="Image descriptive 2" class="mx-auto mb-4 h-24 w-24 object-cover rounded-full shadow">
            <h3 class="text-xl font-semibold mb-2">Transactions sécurisées</h3>
            <p class="text-gray-600">Votre sécurité est notre priorité. Profitez de transactions rapides et sécurisées.</p>
        </div>
        <!-- Fonctionnalité 3 -->
        <div class="text-center">
            <img src="../assets/images/world.svg" alt="Image descriptive 3" class="mx-auto mb-4 h-24 w-24 object-cover rounded-full shadow">
            <h3 class="text-xl font-semibold mb-2">Support 24/7</h3>
            <p class="text-gray-600">Besoin d'aide? Notre équipe est là pour vous assister à tout moment.</p>
        </div>
    </div>
    <div class="text-center mt-8">
        <a href="link_to_app" class="bg-blue-500 hover:bg-blue-600 text-white font-bold py-2 px-6 rounded-full">Découvrez maintenant</a>
    </div>
</section>


</template>

